<template>
  <div id="app">
    <page-header v-if="$route.meta.pageTitle"></page-header>
    <router-view />
  </div>
</template>

<script>
import PageHeader from '@/components/Header.vue'
export default {
  components: {
    PageHeader,
  },
}
</script>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
